module.exports = __webpack_public_path__ + "img/entpremium-icon.5470fade.png";